import axios from 'axios'
import Vue from 'vue'

var queryString = window.location.search
var currentPage = window.location.pathname

function getQueryVariable(variable) {
  var query = queryString.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

var params = {
  secret: getQueryVariable('secret')
}

var axiosNonLoading = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-type': 'application/json' }
})

var axiosSFS = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-type': 'application/json' },
  error_link: ''
})

var axiosUploadFile = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Content-Type': 'multipart/form-data' }
})

function handleError(error) {
  if (!error.response && error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser
    alert('Network Error.\nThe network connection is lost. Please try to reconnect or refresh the page.')
    return
  } else {
    return Promise.reject(error)
  }
}

function intercepterConfig() {
  var count = 0
  var checkSet = null

  axiosNonLoading.interceptors.request.use(
    function (config) {
      return config
    },
    function (error) {
      return handleError(error)
    }
  )

  axiosNonLoading.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      return handleError(error)
    }
  )

  axiosSFS.interceptors.request.use(
    function (config) {
      count++
      Vue.prototype.$bus.$emit('spinner', true)
      clearTimeout(checkSet)
      return config
    },
    function (error) {
      return handleError(error)
    }
  )

  axiosSFS.interceptors.response.use(
    function (response) {
      count--
      if (count == 0) {
        checkSet = setTimeout(() => {
          Vue.prototype.$bus.$emit('spinner', false)
        }, 100)
      }
      axiosSFS.defaults.error_link = ''
      return response
    },
    function (error) {
      count--

      if (count == 0) {
        checkSet = setTimeout(() => {
          Vue.prototype.$bus.$emit('spinner', false)
        }, 100)
      }

      let errMsg = error.toString().replace('AxiosError', 'Error') // hide AxiosError keyword from UI

      // Cleanup and limit error message
      errMsg = errMsg.replace(/<[^>]*>/g, '')
      errMsg = errMsg.substring(0, 100)

      if (!location.href.includes('page-error?error=')) {
        location.href = axiosSFS.defaults.error_link || '/page-error?error=' + encodeURIComponent(errMsg)
      }

      axiosSFS.defaults.error_link = ''
      return handleError(error)
    }
  )

  axiosUploadFile.interceptors.request.use(
    function (config) {
      count++
      Vue.prototype.$bus.$emit('spinner', true)
      clearTimeout(checkSet)
      return config
    },
    function (error) {
      return handleError(error)
    }
  )

  axiosUploadFile.interceptors.response.use(
    function (response) {
      count--
      if (count == 0) {
        checkSet = setTimeout(() => {
          Vue.prototype.$bus.$emit('spinner', false)
        }, 100)
      }
      return response
    },
    function (error) {
      count--
      if (count == 0) {
        checkSet = setTimeout(() => {
          Vue.prototype.$bus.$emit('spinner', false)
        }, 100)
      }
      let errMsg = error.toString().replace('AxiosError', 'Error') // hide AxiosError keyword from UI

      // Cleanup and limit error message
      errMsg = errMsg.replace(/<[^>]*>/g, '')
      errMsg = errMsg.substring(0, 100)

      location.href = '/page-error?error=' + encodeURIComponent(errMsg)
      return handleError(error)
    }
  )
}

export { axiosSFS, axiosUploadFile, axiosNonLoading, params, intercepterConfig }
